<div tabindex="-1" role="dialog" aria-labelledby="confirmDialogTitle" aria-hidden="true">
  <div role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onDecline()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ message }}</p>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <button type="button" class="btn btn-secondary me-2" (click)="onDecline()">
          {{ 'dataform.implementation.file_upload.reject_btn' | translate }}
        </button>
        <button type="button" class="btn btn-danger" (click)="onAccept()">
          {{ 'dataform.implementation.file_upload.confirm_btn' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
